import { baseFetch, textFetch } from './fetch'

export { baseFetch, textFetch }
